import React from 'react';
import PropTypes from 'prop-types';
import FlagIconFactory from 'react-flag-icon-css';

const Flag = ({ code }) => {
  const FlagIcon = FlagIconFactory(React, { useCssModules: false });

  return (
    <div>
      {(code.toLowerCase() !== 'unknown' && code.toLowerCase() !== 'not found')
        && (<FlagIcon className="mr-1" code={code.toLowerCase()} />)}
      {code.toLowerCase()}
    </div>
  );
};

Flag.propTypes = {
  code: PropTypes.string.isRequired,
};

export default Flag;
